import Lookup from 'src/componentes/select2';

const MovimentacaoFinanceiraEntidadeLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/MovimentacaoFinanceiraEntidadeLookup"
    clearable={true}
    {...rest}
  />
);

export default MovimentacaoFinanceiraEntidadeLookup;
